import { Component, OnInit, Inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"
import { IconImageService } from "@shared/services/icon-image.service"
@Component({
  selector: "illustration-dialog",
  standalone: false,
  templateUrl: "./illustration-dialog.component.html",
  styleUrl: "./illustration-dialog.component.scss",
})
export class IllustrationDialogComponent implements OnInit {
  public chosenIllustration: { Title: string; Url: string } = { Title: "", Url: "" }
  public illustrationData: { Title: string; Url: string }[] = []
  public doneLoading: boolean = false
  public selectedIllustration: { Title: string; Url: string } = { Title: "", Url: "" }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<IllustrationDialogComponent>, public iconService: IconImageService) {
    this.chosenIllustration = data.chosenIllustration
    if (this.chosenIllustration) {
      this.selectedIllustration = this.chosenIllustration
    }
  }

  ngOnInit(): void {
    this.illustrationData = Object.entries(this.iconService.AudienceIllutrations).map(([key, value]) => {
      return {
        Title: key,
        Url: value,
      }
    })
    this.doneLoading = true
  }

  selectIllustration(illustration: { Title: string; Url: string }) {
    this.selectedIllustration = illustration
  }

  closeDialog() {
    this.dialogRef.close(false)
  }
  save() {
    this.dialogRef.close(this.selectedIllustration)
  }
}
